export default "__VITE_ASSET__og$GRD$s__"